// The Finance Forecaster mark: one continuous curve moving up and to the right.
// The first stroke is where the money has been (history), the second is where
// it is headed (forecast). The point where they meet is now. Geometry is the
// 1024-grid curve from assets/icon-1024.svg, so every rendering of the mark
// (React, SVG assets, share images, emails) shares the same slopes.
//
// Brand rules (docs/brand/Finance-Forecaster-Brand-Book.pdf, 01 Logo):
//   - the forecast stroke is always Forecast Green #10B981; never recolour it
//   - the history stroke is white on Finance Blue, Finance Blue on white
//   - do not change the number or gradient of the slopes
//   - minimum size: icon 48px; horizontal lockup 240px wide
//   - clear space: the height of the "F" on every side

export const MARK_VIEWBOX = '0 0 1024 1024';
export const HISTORY_PATH = 'M120 550 C 300 530, 500 440, 700 180';
export const FORECAST_PATH = 'M700 180 C 750 120, 800 70, 860 30';
export const MARK_STROKE = 18;

// Tight bounding box of the curve inside the 1024 grid (stroke included), used
// by the line-only variants so the curve fills its box without the icon's tile.
export const CURVE_BOX = { x: 110, y: 20, width: 760, height: 540 };

export const BRAND = {
  blue: '#3361FF',
  green: '#10B981',
  midnight: '#0B1533',
  mist: '#EEF2FF',
  white: '#FFFFFF',
};
